export default "__VITE_ASSET__DGl$WCj7__"